{
  "contactModal": {
    "delete": {
      "cancel": "Cancelar",
      "confirm": "Eliminar",
      "error": {
        "contactWithInformationRequests": "No es posible eliminar el contacto con solicitudes de información asignadas",
        "default": "Error al eliminar el contacto",
        "title": "Error al eliminar el contacto"
      },
      "message": "¿Estás seguro de que quieres eliminar este contacto?",
      "success": "Contacto eliminado correctamente",
      "title": "Eliminar contacto"
    }
  },
  "contacts": {
    "buttons": {
      "add": "Agregar un contacto"
    },
    "table": {
      "headers": {
        "actions": "Acciones",
        "email": "Correo electrónico",
        "id": "ID",
        "name": "Nombre"
      }
    }
  },
  "onboarding": {
    "actions": {
      "activateAccount": "Activar cuenta",
      "back": "← Atrás",
      "next": "Siguiente"
    },
    "ariaLabel": "Pasos de incorporación",
    "gate": {
      "retryBanner": {
        "message": "Ocurrió un error. Por favor, actualice y vuelva a intentarlo.",
        "retry": "Volver a intentarlo"
      }
    },
    "placeholder": "Contenido del paso próximamente.",
    "stepIndicator": "Paso {{current}} de {{total}}",
    "steps": {
      "my_facilities": {
        "name": "Instalaciones",
        "subtitle": "Indícanos con qué instalaciones de producción trabajas y su empresa matriz.",
        "title": "Añade tus instalaciones de producción"
      },
      "register_bp": {
        "name": "Socios comerciales",
        "subtitle": "Lista los contactos clave de las organizaciones socias — compradores, agentes o subcontratistas a los que debemos contactar para solicitudes de trazabilidad.",
        "title": "Añade tus socios comerciales"
      },
      "review": {
        "name": "Revisión",
        "subtitle": "Comprueba que todo esté correcto antes de activar tu cuenta.",
        "title": "Revisa tus datos"
      },
      "verify_company": {
        "name": "Verificar empresa",
        "subtitle": "Confirma que tenemos la empresa correcta antes de continuar.",
        "title": "Verifica el perfil de tu empresa"
      },
      "welcome": {
        "name": "Bienvenida",
        "subtitle": "",
        "title": "Bienvenido a Trace for Good"
      }
    },
    "verifyCompany": {
      "outcomes": {
        "answer_on_behalf": {
          "description": "For consultants, agents or partners filling in for the company shown above. Next, you'll register your company — responses stay attributed to you as their agent.",
          "label": "This is not my company, but I'm responding on their behalf"
        },
        "claim_company": {
          "description": "Confirm the profile above and continue setup as an employee of this company.",
          "label": "Yes, this is my company — I'd like to validate it"
        },
        "not_related": {
          "description": "Stops this verification. The person who invited you to Trace For Good will be notified so they can rectify the company shown above.",
          "label": "This isn't my company"
        }
      },
      "prompt": "Is this the profile of the company you are working at?",
      "summary": {
        "city": "City",
        "country": "Country",
        "street": "Street"
      }
    },
    "welcome": {
      "checkInfo": "Antes de acceder a tu cuenta de Trace for Good, nos gustaría comprobar algunos datos contigo.",
      "intro": "Nos alegra tenerte a bordo. Este portal ha sido diseñado para facilitar la colaboración entre socios comerciales de múltiples cadenas de suministro en el contexto de la trazabilidad de productos y el cumplimiento normativo.",
      "invitation": "Has sido invitado a la plataforma Trace for Good por <strong>{{invitingCompanyName}}</strong> para participar en un proceso de trazabilidad de productos. Este proceso puede requerir que proporciones información sobre las cadenas de suministro."
    }
  },
  "productionSiteModal": {
    "actions": {
      "addRegistrationId": "Agregar ID de registro",
      "backToProductionSite": "Volver al formulario del sitio",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "removeRegistrationId": "Eliminar ID de registro",
      "save": "Guardar"
    },
    "createTitle": "Nuevo sitio de producción",
    "delete": {
      "cancel": "Cancelar",
      "confirm": "Eliminar",
      "message": "¿Estás seguro de que quieres eliminar este sitio de producción?",
      "title": "Eliminar sitio de producción"
    },
    "editTitle": "Editar un sitio de producción",
    "errors": {
      "cityRequired": "La ciudad es requerida",
      "coordinatesMaxDecimals": "La latitud y la longitud pueden tener como maximo 6 decimales",
      "countryMustBeValid": "País debe ser válido (ex. FR, DE)",
      "internalCodeTooLong": "El código interno debe tener menos de 32 caracteres",
      "nameRequired": "Nombre es requerido",
      "parentCompanyRequired": "La empresa madre es obligatoria",
      "postalCodeTooShort": "El código postal debe tener al menos 3 caracteres",
      "streetRequired": "La calle es requerida",
      "streetTooShort": "La calle debe tener al menos 3 caracteres"
    },
    "labels": {
      "city": "Ciudad",
      "country": "País",
      "internalCode": "Código interno",
      "latitude": "Latitud",
      "longitude": "Longitud",
      "name": "Nombre del sitio de producción",
      "parentCompany": "Empresa madre",
      "performedActivities": "Actividades realizadas",
      "postalCode": "Código postal",
      "registrationId": "IDs de registro del sitio",
      "street": "Calle"
    },
    "parentCompanyChange": {
      "cancel": "Mantener la empresa madre actual",
      "confirm": "Cambiar empresa madre",
      "message": "La empresa madre es la empresa a la que pertenece este sitio. Cambiarla actualizará la propiedad de esta instalación y puede afectar el enrutamiento de la trazabilidad.",
      "title": "¿Cambiar la empresa madre?"
    },
    "placeholders": {
      "city": "Ciudad",
      "country": "Seleccione el país del sitio",
      "internalCode": "ej. BD-DAK-001 o su referencia interna",
      "latitude": "Latitud",
      "longitude": "Longitud",
      "name": "ej. Unidad Corte y Confección Dhaka A",
      "parentCompany": "ej. Trace for Good",
      "performedActivities": "ej. Corte, costura, acabado, teñido",
      "postalCode": "ej. 75008",
      "registrationId": "ej. CIF, CIN, GSTIN, USC",
      "street": "ej. 12 rue des Fleurs"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS: 9 dígitos.",
      "EORI": "EORI: código país + 14 dígitos.",
      "GLN": "GLN: 13 dígitos.",
      "OTHER": "Otro: máx. 32 caracteres.",
      "RCS": "RCS: RCS + espacio + nombre empresa + espacio + [A,B] + espacio + 9 dígitos.",
      "VAT": "VAT: código país (ej. FR) + 2 dígitos + 9 dígitos SIREN."
    },
    "registrationIdErrors": {
      "DUNS": "El ID de registro DUNS debe ser un número de 9 dígitos.",
      "EORI": "El ID de registro EORI debe tener el formato: código país (ej. FR) + 14 dígitos.",
      "GLN": "El ID de registro GLN debe ser un número de 13 dígitos.",
      "OTHER": "El ID de registro otro debe tener menos de 32 caracteres.",
      "RCS": "El ID de registro RCS debe tener el formato: RCS + espacio + nombre empresa + espacio + [A,B] + espacio + 9 dígitos.",
      "VAT": "El ID de registro VAT debe tener el formato: código país (ej. FR) + clave 2 dígitos + número SIREN 9 dígitos."
    },
    "tabs": {
      "generalInfo": "Información general",
      "location": "Ubicación"
    },
    "tooltips": {
      "address": "Tu dirección de envío",
      "city": "Ciudad del sitio de producción",
      "country": "País del sitio de producción",
      "internalCode": "Código interno del sitio de producción",
      "latitude": "Latitud del sitio de producción",
      "longitude": "Longitud del sitio de producción",
      "name": "Nombre del sitio de producción",
      "parentCompany": "Empresa propietaria de la instalación, seleccionada de la lista de socios comerciales registrados.",
      "parentCompanyEdit": "Seleccione la empresa propietaria de este sitio.",
      "parentCompanyReadOnly": "Solo la organización que creó o posee esta instalación puede cambiar la empresa madre.",
      "performedActivities": "Actividades realizadas en el sitio de producción",
      "postalCode": "Código postal del sitio de producción",
      "registrationId": "IDs de registro del sitio de producción",
      "street": "Calle del sitio de producción"
    }
  },
  "productionSites": {
    "buttons": {
      "add": "Agregar un sitio de producción"
    },
    "create": {
      "error": "Error al crear el sitio de producción",
      "successCreated": {
        "message": "El sitio de producción ha sido creado correctamente",
        "title": "Sitio de producción creado"
      },
      "successMerged": {
        "message": "Ya existe en su repositorio un sitio de produccion con este nombre y direccion.",
        "title": "Sitio de produccion existente encontrado"
      }
    },
    "delete": {
      "error": "Error al eliminar el sitio de producción",
      "success": {
        "message": "El sitio de producción ha sido eliminado correctamente",
        "title": "Sitio de producción eliminado"
      }
    },
    "filters": {
      "country": "País",
      "internalCode": "Código interno del sitio de producción",
      "isConfidential": "Confidencial",
      "isConfidentialFalse": "No",
      "isConfidentialTrue": "Sí",
      "name": "Nombre del sitio de producción",
      "nothingFoundMessage": "No se encontraron resultados",
      "performedActivities": "Actividades realizadas",
      "searchPlaceholder": "Buscar filtros",
      "title": "Filtros"
    },
    "search": {
      "placeholder": "Buscar por nombre o dirección"
    },
    "sorts": {
      "address": "Dirección",
      "country": "País",
      "email": "Correo electrónico",
      "internalCode": "Código interno",
      "name": "Nombre"
    },
    "table": {
      "headers": {
        "address": "Dirección",
        "certificates": "Certificados",
        "deleted": "Eliminado",
        "id": "ID",
        "internalCode": "Código interno",
        "name": "Nombre",
        "parentCompany": "Empresa madre",
        "performedActivities": "Actividades realizadas",
        "registrationId": "IDs de registro del sitio"
      }
    },
    "title": "Sitios de Producción",
    "update": {
      "error": "Error al actualizar el sitio de producción",
      "partialSave": {
        "message": "message"
      },
      "success": {
        "message": "El sitio de producción ha sido actualizado correctamente",
        "title": "Sitio de producción actualizado"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Error"
    }
  }
}
